var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-example-child md-example-child-result-page md-example-child-result-page-2"},[_c('md-result-page',{attrs:{"type":"empty","buttons":_vm.buttons}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }